module.exports = __webpack_public_path__ + "img/funDeatilNew.70479ae9.png";